// Autogenerated from `packages/@members/copy/copy.generated/__copy__.ts.hbs`

import { toCopyComponent, toFormattedText } from '@peloton/copy';
import type { CopyHook } from '@peloton/copy-generic';
import type { CopyIDs } from '../CopyIDs';
import { useAllCopy } from '../CopyProvider/CopyProvider';
import type { GuestPass } from '../models.generated';

export const useGuestPass: CopyHook<CopyIDs<typeof GuestPass>> = (id, values) => {
  const copy = useAllCopy();
  const value = copy?.guestPassCollection?.[id];

  if (!value) {
    console.error(`No copy found for id ${id}`);
    return '';
  }

  return toFormattedText(value, values) as string;
};

export const GuestPassCopy = toCopyComponent(useGuestPass);
